// extracted by mini-css-extract-plugin
module.exports = {"comment_controls":"dece2e673c--comment_controls--3mFVR"};